import { IFormViewForm } from 'components/FormView';

const DashboardDetailsForm: IFormViewForm = {
  id: 'DashboardDetailsForm',
  layout: {
    rows: 1,
    columns: 2
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 0,
          type: 'TEXT_FIELD',
          props: {
              label: 'Dashboard',
              name: 'Description',
              placeholder: '',
              size: 'large',
              required: true,
          },
        },
        {
          id: 1,
          type: 'SELECT_FIELD',
          visible: true,
          props: {
            label: 'Dashboard type',
            name: 'DashboardType',
            placeholder: '',
            size: 'medium',
            apiPrefs: {
              path: '/CustomTypes/Lookup/DashboardType',
              method: 'GET',
              params: null
            },
          }
        },
        {
          id: 2,
          type: 'SELECT_FIELD',
          visible: true,
          props: {
            label: 'Dashboard layout',
            name: 'LayoutType',
            placeholder: '',
            size: 'medium',
            apiPrefs: {
              path: '/CustomTypes/Lookup/DashboardLayout',
              method: 'GET',
              params: null
            },
          }
        },
        {
          id: 2,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Responsible user',
            size: 'medium',
            name: 'UserId',
            required: true,
            lookupName: 'Personnel',
          }
        },
        {
          id: 3,
          type: 'TOGGLE_FIELD',
          props: {
            label: 'Active dashboard',
            size: 'small',
            name: 'Active',
          }
        },
      ]
    }
  ]
};

export default DashboardDetailsForm;
